import * as React from 'react'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { EnvironmentSelectorState } from '../../../../common/environment/reducer'
import { ARMHybridDetail, ARMServer, User } from '../../../../remote-api/models'
import { ResourceSelectorState } from '../../../../common/resource/reducer'
import { VersionSelectorState } from '../../../../common/version/reducer'
import { Profile } from '../../../../remote-api/CoreServicesRemoteApi'
import { BasicAlert } from '../../model'
import BasicAlertModalBody from './BasicAlertModalBody/BasicAlertModalBody'
import ModalHeader from '@mulesoft/anypoint-components/lib/ModalHeader'
import ModalBody from '@mulesoft/anypoint-components/lib/ModalBody'
import Modal from '@mulesoft/anypoint-components/lib/Modal'
import './BasicAlertModal.css'

export type ValueProps = {
  organizationId: string
  isBasicAlertModalOpened: boolean
  existingAlert?: BasicAlert
  servers: ARMServer[]
  serversLoading: boolean
  environmentSelector: EnvironmentSelectorState
  resourceSelector: ResourceSelectorState
  versionSelector: VersionSelectorState
  serverApplications?: ARMHybridDetail[]
  profile?: Profile
  users: User[]
  emailTemplateEnabled: boolean
  apiAlertsEnabled: boolean
  apiResponseCodesLimit: number
  hasEditRole?: boolean
  isBasicAlertsLimitExceeded: boolean
}

export type EventProps = {
  load: (envId?: string, resourceId?: string, versionId?: string, targetId?: string) => void
  fetchUsers: (search: string, limit: number, offset: number) => Promise<{ data: User[] }>
  changeUsers: (users: User[]) => void
  environmentSelected: (environmentId: string) => void
  resourceSelected: (resourceId: string, resourceType: ResourceType) => void
  versionSelected: (versionId: string) => void
  saveBasicAlert: (alert: BasicAlert) => void
  deleteBasicAlert: (alert: BasicAlert) => void
  handleOpen: () => void
  handleClose: () => void
  cleanResourcesSelectors: () => void
}

export type Props = ValueProps & EventProps

export default class BasicAlertModal extends React.Component<Props> {

  constructor(props: Props) {
    super(props)
  }

  getModalBodyProps() {
    return {
      organizationId: this.props.organizationId,
      existingAlert: this.props.existingAlert,
      servers: this.props.servers,
      serversLoading: this.props.serversLoading,
      environmentSelector: this.props.environmentSelector,
      resourceSelector: this.props.resourceSelector,
      serverApplications: this.props.serverApplications,
      profile: this.props.profile,
      users: this.props.users,
      emailTemplateEnabled: this.props.emailTemplateEnabled,
      apiAlertsEnabled: this.props.apiAlertsEnabled,
      apiResponseCodesLimit: this.props.apiResponseCodesLimit,
      hasEditRole: this.props.hasEditRole,
      load: this.props.load,
      fetchUsers: this.props.fetchUsers,
      changeUsers: this.props.changeUsers,
      environmentSelected: this.props.environmentSelected,
      resourceSelected: this.props.resourceSelected,
      versionSelected: this.props.versionSelected,
      versionSelector: this.props.versionSelector,
      saveBasicAlert: this.props.saveBasicAlert,
      deleteBasicAlert: this.props.deleteBasicAlert,
      handleClose: this.props.handleClose,
      cleanResourcesSelectors: this.props.cleanResourcesSelectors,
      isBasicAlertsLimitExceeded: this.props.isBasicAlertsLimitExceeded,
    }
  }

  render() {
    const {existingAlert} = this.props
    const modalBodyProps = this.getModalBodyProps()

    if (this.props.isBasicAlertModalOpened) {
      return (
        <Modal
          testId={'basic-alert-modal'}
          renderInBody={false}
          // onEsc={this.props.handleClose}
          // onClickOverlay={this.props.handleClose}
        >
          <ModalHeader testId={`basic-alert-modal-header${existingAlert ? '-existing-alert-modal-header' : ''}`}>
            {!existingAlert && <h1 data-test-id="new-basic-alert-modal-header-title">Add basic alert</h1>}
            {existingAlert && <h1 data-test-id="existing-basic-alert-modal-header-title">{existingAlert.alertName}</h1>}
          </ModalHeader>
          <ModalBody testId={'basic-alert-modal-body'}>
            <BasicAlertModalBody {...modalBodyProps}/>
          </ModalBody>
        </Modal>
      )
    }
    return null
  }

}
